import HttpUtil from "ips/ac/util/HttpUtil";
import Util from "ips/ac/util/Util";
import Response from "ips/ac/model/types/Response";
import { AppointmentSeriesDto, CreateUpdateRequest } from "ips/ac/model/api/WinDoFlow.api.types";

export default class AppointmentService {

  public static async getAppointmentSeries(sGuid: string): Promise<AppointmentSeriesDto> {
    const response: Response<AppointmentSeriesDto> = await HttpUtil.get(AppointmentService.getBaseUrl() + "/series/" + sGuid);
    return response.content;
  }

  public static async deleteAppointmentSeries(sGuid: string, sAppointmentGuid?: string): Promise<boolean> {
    let sUrl = AppointmentService.getBaseUrl() + "/series/" + sGuid;
    if (sAppointmentGuid) {
      sUrl += "?appointmentGuid=" + encodeURIComponent(sAppointmentGuid);
    }

    const response: Response<boolean> = await HttpUtil.delete(sUrl);
    return response.content;
  }

  public static createAppointment(oPayload: CreateUpdateRequest): Promise<void> {
    return HttpUtil.post(AppointmentService.getBaseUrl() + "/create", null, oPayload);
  }

  public static updateAppointment(oPayload: CreateUpdateRequest): Promise<void> {
    return HttpUtil.put(AppointmentService.getBaseUrl() + "/update", oPayload);
  }

  public static updateAppointmentSeries(oPayload: CreateUpdateRequest): Promise<void> {
    return HttpUtil.put(AppointmentService.getBaseUrl() + "/update-series", oPayload);
  }

  private static getBaseUrl(): string {
    return Util.getPrivateApi() + "/appointment";
  }
}
